import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';
import heroMenu from "./hero-menu";
import headerNav from "./header-nav";
import happyClients from "./happy-clients";
import clientReviews from "./client-reviews";
import lpTestimonials from "./lp-testimonials";
import phoneReplace from "./phone-replace";

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            heroMenu.init();
            headerNav.init();
            happyClients.init();
            clientReviews.init();
            lpTestimonials.init();
            phoneReplace.init();
        });
    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();


